<template>
  <div class="whole">
	<!-- 提币信息确认 -->
	<common-head url="/withdrawMoney" :title="$t('tba.tibiConfirmInfo')" :is-return="true"></common-head>
	
	<div class="layoutBox bgGray">
		<div class="contWhiteBox">
			<div class="list-cell-li">
				<span class="mainFontLightColor">{{ $t('myPledge.currency')}}</span>
				<strong class="mainFontColor">{{ dataForm.token }} 
					<span class="mainColor1 typebtn">
					  {{ dataForm.mainchain }}
					</span>
				</strong>
			</div>
			<div class="list-cell-li">
				<span class="mainFontLightColor">{{ $t('xinzeng.tibidizhi')}}</span>
				<div class="address">
					<strong class="mainFontColor">{{ dataForm.address }}</strong>
				</div>
			</div>
			<div class="list-cell-li">
				<span class="mainFontLightColor">{{ $t('tba.Arrivalquantity')}}</span>
				<strong class="mainFontColor">{{ dataForm.arrival }}</strong>
			</div>
		</div>
		<div class="contWhiteBox" style="margin-bottom: 1.4rem;">
			<div class="comTips comTipsPadd">
				<h3 class="caption">{{ $t('tba.RiskStatement')}}</h3>
				<p>{{ $t('tba.riskTipsText.one')}}</p>
				<p>{{ $t('tba.riskTipsText.two')}}</p>
				<p>{{ $t('tba.riskTipsText.three')}}</p>
				<p>{{ $t('tba.riskTipsText.four')}}</p>
				<p>{{ $t('tba.riskTipsText.five')}}</p>
			</div>
		</div>
		<!-- <div class="comBtnStyle" @click="confirmWithdraw()">{{ $t('tba.yes') }}</div> -->
		<div class="comBtnStyle" @click="WithdrawCode()">{{ $t('tba.yes') }}</div>
	</div>

  </div>
</template>

<script>
import commonHead from '@/components/commonHead';
export default {
	name: "withdrawMoneyInfo",
  components: { commonHead },
  data() {
    return {
	  // 20210415[start]--------
	  dataForm: this.$route.query.dataForm,
    };
  },
  created() {
    if (window.plus) {
      this.plusReady();
    } else {
      document.addEventListener("plusready", this.plusReady, false); //
    }
	// 20210415--------
	this.prepareWithdraw();
	console.log('dataForm', this.dataForm)
  },
  methods: {
	  getInitData() {
		  // username
	  },
	  // ----------20200410[start]----------
	  WithdrawCode() {
		  // this.$router.push('checkVerifyCode');
		  this.$router.push({
			  path: '/checkVerifyCode',
			  query: {
				  dataForm: this.dataForm
			  }
		  });
	  },
	  

    // 申请提现
    prepareWithdraw() {
      this.$post2("Pay/Api/Index/prepareWithdrawConfig", {})
        .then((res) => {
          // console.log(res);
          this.dataForm.txid = res.txid;
        })
        .catch((err) => {
          console.log(err);
        });
    },
	
  },
};
</script>

<style scoped lang="less">
// ----------20200411[start]-----------
.layoutBox {
	min-height: calc(100vh - 1.76rem);
	padding: .1rem .3rem .5rem;
}


.list-cell-li {
	padding: .25rem;
	border-bottom: 1px solid #EDEDED;
	// line-height: .45rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
	position: relative;
	&:last-child {
		border-bottom: 0;
	}
	.address {
		width: 4.4rem;
		word-break: break-all;
		text-align: right;
	}
	.typebtn {
		padding: .02rem .12rem;
		background: #EFF7FF;
		border-radius: .04rem;
		margin-left: .1rem;
	}
}
.comTips {
	color: #999999;
	font-size: .24rem;
	line-height: .45rem;
	&.comTipsPadd {
		color: #666666;
		font-size: .28rem;
		line-height: .4rem;
		padding: .25rem;
	}
	.caption {
		color: #373737;
		font-size: .32rem;
		font-weight: bold;
		line-height: .45rem;
		margin-bottom: .25rem;
	}
	p {
		margin-bottom: .25rem;
		&:last-child {
			margin-bottom: 0;
		}
	}
}
.comBtnStyle {
	color: #FFFFFF;
	font-size: .32rem;
	text-align: center;
	height: .88rem;
	line-height: .88rem;
	background: #90C4FF;
	border-radius: .12rem;
}
// ----------20200411[end]-----------
</style>